import { z } from "zod";

export const genericBooleanSchema = z.boolean();

export type Boolean = z.infer<typeof genericBooleanSchema>;
